import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { actions } from "store"


const useChatMarkupState = () => {
    const dispatch = useDispatch()

    const updateChatMarkup = useCallback((word) => {
        if (word) {
            dispatch(actions.setChatWordMarkup(word))
            dispatch(actions.setIgnoreActions(true))
        }
        else {
            dispatch(actions.setChatWordMarkup(null))
            dispatch(actions.setIgnoreActions(false))
        }
    }, [])

    return updateChatMarkup
}

export default useChatMarkupState